import toast from 'react-hot-toast';

import CustomToast from 'components/common/CustomToast';

export const showSuccessToast = (message: string) => toast.success(message, { position: 'top-right', duration: 3000 });
export const showErrorToast = (message: string) => toast.error(message, { position: 'top-right', duration: 3000 });
export const showCustomToast = (message: string) =>
  toast.custom((t) => <CustomToast {...t} message={message} />, { duration: 9000 });
